import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=331c599b&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331c599b')) {
      api.createRecord('331c599b', component.options)
    } else {
      api.reload('331c599b', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=331c599b&", function () {
      api.rerender('331c599b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Sidebar/Link.vue"
export default component.exports